import React, { useEffect, useState } from "react";

import { Button } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import { HOST_URL } from "../common";

const Reporter = (props) => {
  const [isFinalReported, setIsFinalReported] = useState(false);

  const [todayIssue, setTodayIssue] = useState([]);
  const [nextDayIssue, setNextDayIssue] = useState([]);
  const [etcIssue, setEtcIssue] = useState([]);

  useEffect(() => {
    setIsFinalReported(props.readOnly);
    setTodayIssue(props.today);
    setNextDayIssue(props.nextday);
    setEtcIssue(props.etc);
  }, [props.readOnly, props.date, props.today, props.nextday, props.etc]);

  const handleAddTopic = (rootElement, value) => {
    let root = document.getElementById(rootElement);

    let div = document.createElement("div");
    div.style.display = "flex";
    div.style.width = "100%";
    div.style.alignItems = "flex-end";

    let ta = document.createElement("textarea");

    if (isFinalReported) {
      ta.readOnly = true;
    }

    ta.style.width = "95%";
    ta.style.height = "100px";
    ta.style.borderRadius = "10px";
    ta.style.padding = "10px";
    if (value !== undefined) ta.value = value;

    let deleteBtn = document.createElement("button");
    deleteBtn.style.margin = "5px";
    deleteBtn.style.width = "3%";
    deleteBtn.style.height = "30px";
    deleteBtn.style.borderRadius = "5px";
    deleteBtn.style.backgroundColor = "#1565c0";
    deleteBtn.style.color = "white";
    deleteBtn.style.border = "0";
    deleteBtn.style.boxShadow = "none";

    deleteBtn.innerHTML = "삭제";
    deleteBtn.onclick = function () {
      root.removeChild(div);
    };

    div.appendChild(ta);

    !isFinalReported && div.appendChild(deleteBtn);

    root.appendChild(div);
  };

  const TodayReport = () => {
    useEffect(() => {
      todayIssue.map((content) =>
        handleAddTopic("todayTopic", content[Object.keys(content)[0]])
      );
    }, []);

    return (
      <>
        <div
          style={{
            width: "90%",
            borderStyle: "solid",
            borderColor: "white",
            borderWidth: 1,
            fontSize: 12,
            textAlign: "left",
            padding: 10,
          }}
        >
          <h6>금일업무 진행현황</h6>
          <div
            id="todayTopic"
            style={{ display: "flex", flexDirection: "column" }}
          />
          {isFinalReported === false ? (
            <Button
              variant="contained"
              onClick={() => handleAddTopic("todayTopic")}
              style={{ margin: 5, fontSize: 13 }}
            >
              추가
            </Button>
          ) : (
            <div />
          )}
        </div>
      </>
    );
  };

  const NextDayReport = () => {
    useEffect(() => {
      nextDayIssue.map((content) =>
        handleAddTopic("nextDayTopic", content[Object.keys(content)[0]])
      );
    }, []);

    return (
      <>
        <div
          style={{
            width: "90%",
            borderStyle: "solid",
            borderColor: "white",
            borderWidth: 1,
            fontSize: 12,
            textAlign: "left",
            padding: 10,
          }}
        >
          <h6>진행예정 업무</h6>
          <div
            id="nextDayTopic"
            style={{ display: "flex", flexDirection: "column" }}
          />
          {isFinalReported === false ? (
            <Button
              variant="contained"
              onClick={() => handleAddTopic("nextDayTopic")}
              style={{ margin: 5, fontSize: 13 }}
            >
              추가
            </Button>
          ) : (
            <div />
          )}
        </div>
      </>
    );
  };

  const ETCReport = () => {
    useEffect(() => {
      etcIssue.map((content) =>
        handleAddTopic("ETCTopic", content[Object.keys(content)[0]])
      );
    }, []);

    return (
      <>
        <div
          style={{
            width: "90%",
            borderStyle: "solid",
            borderColor: "white",
            borderWidth: 1,
            fontSize: 12,
            textAlign: "left",
            padding: 10,
          }}
        >
          <h6>협조 및 기타 특기 사항</h6>
          <div
            id="ETCTopic"
            style={{ display: "flex", flexDirection: "column" }}
          />
          {isFinalReported === false ? (
            <Button
              variant="contained"
              onClick={() => handleAddTopic("ETCTopic")}
              style={{ margin: 5, fontSize: 13 }}
            >
              추가
            </Button>
          ) : (
            <div />
          )}
        </div>
      </>
    );
  };

  const handleCancel = () => {
    if (window.confirm("정말로 작성을 중단하고 취소 하시겠습니까 ?")) {
      window.location.href = "/";
    }
  };

  const getEachReport = (topic) => {
    const root = document.getElementById(topic);
    const nodeList = root.childNodes;

    let count = 1;

    let issueArray = [];
    nodeList.forEach((childNode) => {
      const subNodeList = childNode.childNodes;
      subNodeList.forEach((subNode) => {
        let postData = {};
        if (subNode.nodeName === "TEXTAREA") {
          postData[count++] = subNode.value;
          issueArray.push(postData);
        }
      });
    });

    return issueArray;
  };

  const postReport = (todayArray, nextdayArray, etcArray) => {
    const postBody = {
      cmd: "post",
      date: props.date,
      todayissue: todayArray,
      nextdayissue: nextdayArray,
      etcissue: etcArray,
    };

    //const url = 'http://30.30.30.3:3002/report?'
    const url = HOST_URL + ":3002/report?";
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(postBody),
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "ok") {
          toast("임시 저장 되었습니다.");

          setTodayIssue(todayArray);
          setNextDayIssue(nextdayArray);
          setEtcIssue(etcArray);
        } else if (
          result.code === "error" &&
          result.reason === "session error"
        ) {
          toast("임시 저장 실패. 다시 로그인해야합니다.");
        } else {
          toast("알수없는 오류가 발생되었습니다.");
        }
      });
  };

  const handleTemporarySave = () => {
    const todayArray = getEachReport("todayTopic");
    const nextdayArray = getEachReport("nextDayTopic");
    const etcArray = getEachReport("ETCTopic");

    postReport(todayArray, nextdayArray, etcArray);
  };

  const handleSave = () => {
    handleTemporarySave();
    confirmReport();
  };

  const confirmReport = () => {
    const confirm = window.confirm(
      "최종보고를 하면 더 이상 수정이 불가능합니다. \n그래도 진행 하겠습니까?"
    );
    if (confirm) {
      const postBody = { cmd: "confirm", date: props.date };

      //const url = 'http://30.30.30.3:3002/sendmail';
      const url = HOST_URL + ":3002/sendmail";
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(postBody),
        credentials: "include",
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code === "ok") {
            toast("최종 보고 되었습니다.");
            setIsFinalReported(true);
          } else if (
            result.code === "error" &&
            result.reason === "session error"
          ) {
            toast("임시 저장 실패. 다시 로그인해야합니다.");
          } else {
            console.log(result);
            toast("알수없는 오류가 발생되었습니다.");
          }
        });
    }
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="Main-container">
      <Toaster />
      <div style={{ width: "90%", padding: 20 }}>
        <h2>My Daily Report {isFinalReported && "(완료)"}</h2>
        <h6 style={{ display: "flex", justifyContent: "flex-end" }}>
          [ {props.date} ] {props.name}
        </h6>
      </div>

      <TodayReport content={props.today} />
      <NextDayReport content={props.nextday} />
      <ETCReport content={props.etc} />
      {isFinalReported === false ? (
        <div style={{ padding: 10 }}>
          <Button
            style={{ padding: 5, margin: 5 }}
            variant="outlined"
            onClick={handleCancel}
          >
            취소
          </Button>
          <Button
            style={{ padding: 5, margin: 5 }}
            variant="contained"
            onClick={handleTemporarySave}
          >
            임시저장
          </Button>
          <Button
            style={{ padding: 5, margin: 5 }}
            variant="contained"
            onClick={handleSave}
          >
            최종보고
          </Button>
        </div>
      ) : (
        <div>
          <Button
            style={{ padding: 5, margin: 5 }}
            variant="contained"
            onClick={handleGoBack}
          >
            뒤로
          </Button>
        </div>
      )}
    </div>
  );
};

export default Reporter;
